import AxiosConfig from '@/config/axios-config'

export const TopicoAPI = {

  editar (topico) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/topicos/${topico.id}`, topico).then(response => response.data)
  }
}

export default TopicoAPI
